// extracted by mini-css-extract-plugin
export default {"wrapper":"loader_wrapper__EisJ1","loader":"loader_loader__qZv+U"};